import React, { useEffect } from "react";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import GenricTable from "../../components/GenricTable";
import LineChartGradient from "../../components/Graphs/LineChartGradient";
import Filters from "../../components/Filters";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../components/Loader";
import Footer from "../../components/Footer";
import { getAnalyticsUtterances } from "../../services/graphs/actions";
import NoDataAvailable from "../../components/NoDataAvailable";

const Utterance = () => {
  const dispatch = useDispatch();
  const {
    analytics_utterances,
    range,
    app,
    isLoading,
    //  error
  } = useSelector(({ graphState, filtersState }) => ({
    analytics_utterances: graphState.analytics_utterances,
    range: filtersState.range,
    app: filtersState.app,
    isLoading: graphState.isLoading,
    error: graphState.error,
  }));
  const fetch = () => {
    dispatch(
      getAnalyticsUtterances({
        platform: app.platform,
        apiKey: app.apiKey,
        fromDate: range.from,
        toDate: range.to,
      })
    );
  };
  useEffect(() => {
    fetch();
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <div className="intents_container">
        {isLoading && <Loader />}
        <Navbar />
        <Sidebar />
        <div style={{ padding: `0 20px` }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr auto" }}>
            <h1>Utterances</h1>
            <h2>{app.name}</h2>
          </div>
          <Filters fetch={fetch} />
        </div>
        <div className="content">
          <div className="half_section">
            <h2>Total Utterances</h2>
            {analytics_utterances &&
            analytics_utterances.totalUtteranceData &&
            analytics_utterances.totalUtteranceData.message === "available" ? (
              <LineChartGradient
                data={analytics_utterances.totalUtteranceData.data[0].series}
                title={"Total Utterance"}
                categories={
                  analytics_utterances.totalUtteranceData.data[1].categories
                }
              />
            ) : (
              <NoDataAvailable title="Total Utterance" />
            )}
          </div>
          <div className="half_section">
            <h2>Top Utterances</h2>
            <GenricTable
              isUtterance={true}
              data={
                analytics_utterances && analytics_utterances.topUtterancesData
              }
            />
          </div>
          <div className="full_section">
            <h2>Average of users utterances</h2>
            {analytics_utterances &&
            analytics_utterances.averageUtteranceData &&
            analytics_utterances.averageUtteranceData.message ===
              "available" ? (
              <LineChartGradient
                data={analytics_utterances.averageUtteranceData.data[0].series}
                categories={
                  analytics_utterances.averageUtteranceData.data[1].categories
                }
                title={"Average user utterance"}
              />
            ) : (
              <NoDataAvailable title="Total Utterance" />
            )}
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Utterance;
